import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Slider,
  IconButton,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { useTheme } from "../../context/ThemeContext";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import styles from "./MemoryDialog.module.scss";

const MemoryDialog = ({ open, onClose, onSave, initialData }) => {
  const { isDarkMode } = useTheme();

  const muiTheme = createTheme({
    palette: {
      mode: isDarkMode ? "dark" : "light",
      primary: {
        main: "#e36250 !important",
      },
      secondary: {
        main: "#8b5cf6",
      },
    },
  });

  const safeInitialData = initialData || {};
  const [formData, setFormData] = useState({
    maxMessages: safeInitialData.maxMessages || 10,
  });

  useEffect(() => {
    if (open) {
      setFormData({
        maxMessages: safeInitialData.maxMessages || 10,
      });
    }
  }, [open, initialData, safeInitialData.maxMessages]);

  const handleSliderChange = (value) => {
    setFormData((prev) => ({
      ...prev,
      maxMessages: value,
    }));
  };

  const handleSave = () => {
    onSave(formData);
    onClose(formData);
  };

  const handleCancel = () => {
    onClose(formData);
  };

  return (
    <ThemeProvider theme={muiTheme}>
      <Dialog
        open={open}
        onClose={() => onClose(formData)}
        maxWidth={false}
        fullWidth
        scroll="paper"
        className={styles.dialog}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(24, 24, 27, 0.4)",
              backdropFilter: "blur(2px)",
            },
          },
        }}
        PaperProps={{
          className: styles.dialogPaper,
        }}
      >
        <DialogTitle className={styles.dialogTitle} component="div">
          <Box className={styles.titleRow}>
            <Typography component="h3" variant="h6" className={styles.title}>
              Configure Memory
            </Typography>
          </Box>
          <IconButton
            onClick={() => onClose(formData)}
            size="small"
            className={styles.closeButton}
            aria-label="Close"
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent className={styles.dialogContent}>
          <Box className={styles.formContainer}>
            {/* Memory Configuration */}
            <Box className={styles.section}>
              <Typography variant="body2" className={styles.sectionLabel}>
                Max. messages stored as Short-term Memory <span className={styles.required}>*</span>
              </Typography>
              
              <Box className={styles.sliderContainer}>
                <Box className={styles.sliderLabels}>
                  <Typography variant="caption" className={styles.sliderMinLabel}>
                    2
                  </Typography>
                  <Typography variant="caption" className={styles.sliderMaxLabel}>
                    50
                  </Typography>
                </Box>
                
                <Slider
                  value={formData.maxMessages}
                  onChange={(e, value) => handleSliderChange(value)}
                  min={2}
                  max={50}
                  step={1}
                  valueLabelDisplay="off"
                  className={styles.slider}
                />
                
                <Box className={styles.valueDisplay}>
                  <Typography variant="body2" className={styles.valueText}>
                    {formData.maxMessages} messages
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>

        <DialogActions className={styles.dialogActions}>
          <Button
            onClick={handleCancel}
            variant="text"
            className={styles.cancelButton}
          >
            Close
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            className={styles.saveButton}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </ThemeProvider>
  );
};

export default MemoryDialog;